import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { ENDPOINT } from "constants/variables";
import "css/generalSettings.css";
import { warningErrorAction } from "actions/ErrorActions";
import ReportTemplateSHEET from 'pages/sheet/generatePDF/ReportTemplateSHEET'; 
import { helpHttp } from "service/HelpHttp";
import PropTypes from 'prop-types'; 

const initialStateSheet = {
  id : "",
  ownsheet_id : "", 
  defaultStore_id:0,
  tradenam:"",
  useraccount_id:0,
  username:"",
  num_sheet:"",
  date_sheet:"",
  vehicle_model:"",
  vehicle_sheet:"",
  frame_sheet:"",
  sheetStatus_id:  1,
  sheetStatus_namees: "",
  sheetStatus_nameen: "",
  isFinished: false,
  productLinesheet:[],
  productliquidLinesheet:[] 
};
 
const SHEETPDF = ({ rowEditSHEET, viewPDF, setViewPDF }) => {
  const { t, i18n } = useTranslation(['listDataForms']);
  const token = useSelector((state) => state.loginUser.token);
  const [dataSHEET, setDataSHEET] = useState(initialStateSheet);   

  const dispatch = useDispatch();
  useEffect(() => {
    let isMounted = true;  
    const fetchDataForm = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT, `sheet/getsheetpdfbyid/`, token, rowEditSHEET.id);
        if (getData.err) {
          setDataSHEET(initialStateSheet);
          dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailed' : 'Text_InvalidCredentials')));
        } else if (isMounted) {
          setDataSHEET(getData);  
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      } 
    };
    if ( rowEditSHEET?.id &&  rowEditSHEET.id !== "0" && rowEditSHEET.id !== "0" && viewPDF) {
      fetchDataForm();
    }
    return () => {isMounted = false;};
  }, [rowEditSHEET, dispatch, t, token,i18n.language,setViewPDF,viewPDF]);  
  return (
      <div id="pdf-content" style={{ padding: 10 }}>
        {(viewPDF && dataSHEET.id!==undefined  && dataSHEET.id!==null  && dataSHEET.id!=="" && dataSHEET.id!=="0" && dataSHEET.id!==0) &&
          <ReportTemplateSHEET dataSHEET={dataSHEET}  initialStateSheet={initialStateSheet} setDataSHEET={setDataSHEET} setViewPDF={setViewPDF}/>
        }   
      </div>   
  );
};

SHEETPDF.propTypes = {
  rowEditSHEET: PropTypes.object.isRequired,
  viewPDF: PropTypes.bool.isRequired,
  setViewPDF: PropTypes.func.isRequired
};

export default SHEETPDF;
